import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import ToastProvider from './ui/ToastProvider';
import './index.css'
import { ConfigProvider, theme as antdTheme } from 'antd';

ReactDOM.render(
  <React.StrictMode>
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#006971',
          colorInfo: '#006971',
          colorBorder: '#e5e7eb',
          colorText: '#0f172a',
          borderRadius: 8,
        },
        components: {
          Input: {
            activeShadow: '0 0 0 3px rgba(0,77,84,0.14)'
          },
          Select: {
            activeShadow: '0 0 0 3px rgba(0,77,84,0.14)'
          },
          DatePicker: {
            activeShadow: '0 0 0 3px rgba(0,77,84,0.14)'
          },
          InputNumber: {
            activeShadow: '0 0 0 3px rgba(0,77,84,0.14)'
          }
        }
      }}
    >
      <ToastProvider>
        <App />
      </ToastProvider>
    </ConfigProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
